<template>
    <b-card align="left" :title="titulo" border-variant="light">
        <b-card-text>
            <b-form @submit.prevent="guardar" @reset="cancelar">
                <b-form-group label-for="gestion" label="Gestión:" label-size="lg">
                <b-form-input id="gestion" :value="gestion" size="lg" class="mb-3" readonly></b-form-input>
                </b-form-group>
                <b-form-group label-for="distrito" label="Distrito:" invalid-feedback="Ingrese por lo menos 5 caracteres" label-size="lg">
                <b-form-input id="distrito" v-model="distrito" :state="distritoValido" size="lg" class="mb-3" autocomplete="off" placeholder="Ingrese distrito" autofocus required trim></b-form-input>
                </b-form-group>
                <b-form-group label-for="nombre" label="Unidad Educativa:" :invalid-feedback="colegioNoValido" label-size="lg">
                <b-form-input id="nombre" v-model="nombre" :state="nombreValido" size="lg" class="mb-3" autocomplete="off" placeholder="Ingrese nombre colegio" required trim></b-form-input>
                </b-form-group>
                <b-form-group label-for="turno" label="Turno:" invalid-feedback="Ingrese por lo menos 5 caracteres" label-size="lg">
                <b-form-input id="turno" v-model="turno" :state="turnoValido" size="lg" class="mb-3" autocomplete="off" placeholder="Ingrese turno" required trim></b-form-input>
                </b-form-group>
                <b-button type="submit" variant="danger" size="lg" class="mt-3">Guardar</b-button>
                <b-button type="reset" size="lg" class="ml-3 mt-3">Cancelar</b-button>
            </b-form>
        </b-card-text>
        <b-alert :show="mostrarAlerta===true" variant="danger" dismissible class="mt-5">{{mensaje}}</b-alert>
    </b-card>    
</template>
<script>
import {mapState, mapMutations} from 'vuex'
export default {
    name: 'Colegio',
    props: {
        titulo: String,
        estado: String
    },
    data(){
        return {
            gestion: 0,
            distrito: '',
            nombre: '',
            turno: '',
            colegio_id: null,
            mostrarAlerta: false,
            mensaje: ''
        }
    },
    created() {
        //console.log('Modo: ',this.estado)
        if (this.estado === 'crear')
            this.gestion = this.planilla[0].gestion
        else if (this.estado === 'editar') {
            //this.distrito = 'Quillacollo'
            this.gestion = this.planilla[1].gestion
            this.distrito = this.planilla[1].distrito
            this.nombre = this.planilla[1].nombre
            this.turno = this.planilla[1].turno
            this.colegio_id = this.planilla[1]._id
        }
    },
    computed: {
        ...mapState(['colegios', 'planilla']),
        mostrar: {
            get () { return this.$store.state.mostrar_form_colegio},
            set (valor) {this.$store.commit('mostrarFormColegio',valor)}
        },
        distritoValido() {
            let len = this.distrito.length
            if (len === 0) return null
            if (len > 4) return true
            return false
        },
        nombreValido() {
            let len = this.nombre.length
            if (len === 0) return null
            if (len > 4) {
                return this.existeColegio(this.nombre, this.distrito, this.gestion, this.colegio_id) ? false: true
            }
            return false
        },
        turnoValido() {
            let len = this.turno.length
            if (len === 0) return null
            if (len > 4) return true
            return false
        },
        colegioNoValido() {
            if (!this.nombreValido) return 'Ya existe!!'
            else return 'Ingrese por lo menos 5 caracteres'
        }
    },
    methods: {
        ...mapMutations(['agregarColegio','actualizarColegio']),
        existeColegio(nombre, distrito, gestion, id) {
            //console.log('Tipo de gestion: '+typeof(gestion)+', valor=', gestion)
            return this.colegios.some(item => item.nombre.toUpperCase() === nombre.toUpperCase() && item.distrito.toUpperCase() === distrito.toUpperCase() && item.gestion === gestion && item._id !== id)
        },
        guardar() {
            //console.log(this.estado)
            if (this.distritoValido && this.nombreValido && this.turnoValido) {
                if (this.estado === 'crear') {
                    this.axios.post('/colegios', {distrito: this.distrito, nombre: this.nombre, turno: this.turno, gestion: this.gestion})
                        .then(res => {
                            this.agregarColegio(res.data)
                            this.distrito = ''
                            this.nombre = ''
                            this.turno = ''
                            this.mostrar = false
                        })
                        .catch(e => {
                            //console.log(e)
                            this.mensaje = 'ERROR: ' + e
                            this.mostrarAlerta = true
                        })
                } else {
                    //update
                    console.log('Por actualizar colegio...')
                    this.axios.put(`/colegios/${this.colegio_id}`,{distrito: this.distrito, nombre: this.nombre, turno: this.turno})
                        .then(res => {
                            this.actualizarColegio(res.data)
                            this.distrito = ''
                            this.nombre = ''
                            this.turno = ''
                            this.mostrar = false
                        })
                        .catch(e => {
                            //console.log(e)
                            this.mensaje = 'ERROR: ' + e
                            this.mostrarAlerta = true
                        })
                }
            }
        },
        cancelar() {
            this.distrito = ''
            this.nombre = ''
            this.turno = ''
            this.mostrar = false
        }
    }   
}
</script>